const uppercaseMask = (input: string) => {
  input = input || '';

  const formatedValue = input.toUpperCase();

  return formatedValue;
};

export default uppercaseMask;
